module.exports = __webpack_public_path__ + "static/media/tokenRequestHeader.5543875d.svg";